"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperatedBy = exports.Time = exports.Header = exports.Row = exports.FlightStop = exports.Flight = exports.AirlineName = exports.Container = exports.ArrowColumn = exports.Column = exports.City = exports.ArrowIcon = exports.Airline = exports.Airports = exports.AirportInfo = exports.Airport = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _ColorIcon = _interopRequireDefault(require("../ColorIcon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

var Airport = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  margin: 0 11px;\n"])), _palette.palette.bobBlack, _widths.font.regular);

exports.Airport = Airport;
Airport.displayName = 'Airport';

var AirportInfo = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.AirportInfo = AirportInfo;
AirportInfo.displayName = 'AirportInfo';

var Airports = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  bottom: 2px;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  position: relative;\n"])));

exports.Airports = Airports;
Airports.displayName = 'Airports';

var Airline = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"])));

exports.Airline = Airline;
Airline.displayName = 'Airline';
var ArrowIcon = (0, _styledComponents["default"])(_ColorIcon["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 10px;\n  margin-right: 10px;\n  align-self: flex-start;\n"])));
exports.ArrowIcon = ArrowIcon;
ArrowIcon.displayName = 'ArrowIcon';

var City = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n"])), _palette.palette.bobBlack, _widths.font.regular);

exports.City = City;
City.displayName = 'City';

var Column = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.Column = Column;
Column.displayName = 'Column';

var ArrowColumn = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n  margin: 12px 8px 0 8px;\n"])));

exports.ArrowColumn = ArrowColumn;
ArrowColumn.displayName = 'ArrowColumn';

var Container = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  background: ", ";\n  border: solid 1px ", ";\n  border-radius: ", "px;\n  display: flex;\n  font-weight: ", ";\n  max-width: ", ";\n  height: 134px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16), 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.16);\n  flex-direction: column;\n  line-height: 22px;\n  &:hover {\n    cursor: pointer;\n  }\n"])), _palette.palette.white, _palette.palette.bobBlack, _widths.widths.base, _widths.font.semi, function (props) {
  return props.maxWidth ? "".concat(props.maxWidth) : '422px';
});

exports.Container = Container;
Container.displayName = 'Container';

var AirlineName = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  margin-right: 4px;\n  text-align: right;\n  ", "\n"])), _palette.palette.bobBlack, _widths.font.medium, function (props) {
  return props.icon && "\n    margin-left: 8px;\n  ";
});

exports.AirlineName = AirlineName;
AirlineName.displayName = 'AirlineName';

var Flight = _styledComponents["default"].span(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n"])), _palette.palette.grey, _widths.font.regular);

exports.Flight = Flight;
Flight.displayName = 'Flight';

var FlightStop = _styledComponents["default"].span(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  text-align: center;\n"])), _palette.palette.grey, _widths.font.regular);

exports.FlightStop = FlightStop;
FlightStop.displayName = 'FlightStop';

var Row = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 56px;\n  margin: 0 16px;\n  ", " {\n    justify-content: center;\n  }\n"])), _widths.mediaQueries.desktop);

exports.Row = Row;
Row.displayName = 'Row';

var Header = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\ndisplay: flex;\nflex-direction: row;\nalign-items: center;\nheight: 48px;\nmargin: 0 16px;\n"])));

exports.Header = Header;
Header.displayName = 'Header';

var Time = _styledComponents["default"].span(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"])), _palette.palette.bobBlack, _widths.widths.base * 3, _widths.font.semi);

exports.Time = Time;
Time.displayName = 'Time';

var OperatedBy = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  height: 32px;\n  margin-left: 16px;\n  ", "\n"])), _palette.palette.grey, _widths.font.regular, function (props) {
  return props.left && "\n    margin-left: auto;\n  ";
});

exports.OperatedBy = OperatedBy;
OperatedBy.displayName = 'OperatedBy';